import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { PageTitle, Tabs } from '../root/components/common'
import { UserPermissions } from '../../services/permissions'
import { ApiKeysContent } from '../api-keys'
import DocumentationTools from './documentation-tools'
import IntegrationsSummary from './integrations-summary'
import { WebhooksContent } from './webhooks'

const TABS = {
    documentationTools: 'documentation-tools',
    apiKeys: 'api-keys',
    webhooks: 'webhooks'
}

const useStyles = makeStyles(() => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    tabs: {
        marginBottom: 24
    }
}))

export default function Integrations() {
    const classes = useStyles()
    const history = useHistory()
    const { tabName = TABS.documentationTools } = useParams()
    const locale = useSelector(state => state.main.locale)
    const { original_customer_id: customerId } = useSelector(
        state => state.main.user
    )

    if (!UserPermissions.location(customerId).read) return null

    const tabs = {
        [TABS.documentationTools]: {
            name: locale.integrations.documentationTools
        },
        [TABS.apiKeys]: {
            name: locale.integrations.apiKeys
        },
        [TABS.webhooks]: {
            name: locale.integrations.webhooks
        }
    }

    const onTabChange = tab => history.push(`/integrations/${tab}`)

    return (
        <div className={classes.wrapper}>
            <PageTitle title={locale.integrations.integrations} />
            <IntegrationsSummary />
            <Tabs
                className={classes.tabs}
                tabs={tabs}
                currentTab={tabName}
                setCurrentTab={onTabChange}
            />
            {tabName === TABS.documentationTools && <DocumentationTools />}
            {tabName === TABS.apiKeys && <ApiKeysContent />}
            {tabName === TABS.webhooks && <WebhooksContent />}
        </div>
    )
}
